const MODE = process.env.mode;

var tempAc = {};

MODE == "development"
  ? (tempAc = {
      urlPrefix: process.env.baseUrlDevelopment,
      apiUrlPrefix: process.env.baseUrlDevelopment + "api/",
      boldRedDelimiter: "~",
      imageAltText: "Unable to load image",
      tollFreeNumber: "+918861039999",
      email: "mail@psolifestyle.com",
    })
  : (tempAc = {
      urlPrefix: process.env.baseUrlDevelopment,
      apiUrlPrefix: process.env.baseUrlDevelopment + "api/",
      boldRedDelimiter: "~",
      imageAltText: "Unable to load image",
      tollFreeNumber: "+918861039999",
      email: "mail@psolifestyle.com",
    });
const AppConfig = tempAc;

export default AppConfig;
